const getValidPlateNumber = (plate, part) => {
  if (!plate) return "";
  try {
    var plateStr = "";
    switch (part) {
      case "1":
        return plate[0] + plate[1];
      case "S":
        switch (plate[2] + plate[3]) {
          case "01":
            return "الف";
          case "02":
            return "ب";
          case "03":
            return "پ";
          case "04":
            return "ت";
          case "05":
            return "ث";
          case "06":
            return "ج";
          case "07":
            return "چ";
          case "08":
            return "ح";
          case "09":
            return "خ";
          case "10":
            return "د";
          case "11":
            return "ذ";
          case "12":
            return "ر";
          case "13":
            return "ز";
          case "14":
            return "ژ";
          case "15":
            return "س";
          case "16":
            return "ش";
          case "17":
            return "ص";
          case "18":
            return "ض";
          case "19":
            return "ط";
          case "20":
            return "ظ";
          case "21":
            return "ع";
          case "22":
            return "غ";
          case "23":
            return "ف";
          case "24":
            return "ق";
          case "25":
            return "ک";
          case "26":
            return "گ";
          case "27":
            return "ل";
          case "28":
            return "م";
          case "29":
            return "ن";
          case "30":
            return "و";
          case "31":
            return "ه";
          case "32":
            return "ی";
          case "33":
            return "D";
          case "34":
            return "S";
          case "35":
            return "&";
          default:
            return "-";
        }
      case "2":
        return plate[4] + plate[5] + plate[6];
      case "3":
        return plate[7] + plate[8];
    }
  } catch (error) {
    return "";
  }
};

const setValidPlateNumber = (p1, pLetter, p2, p3) => {
  try {
    pLetter = pLetter == "الف" ? "ا" : pLetter;
    var plate = p1 + pLetter + p2 + p3;
    var plateLetter = plate[2];
    var resPlate = "";
    var resPlateLetter = "";

    switch (plateLetter) {
      case "ا":
        resPlateLetter = "01";
        break;
      case "ب":
        resPlateLetter = "02";
        break;
      case "پ":
        resPlateLetter = "03";
        break;
      case "ت":
        resPlateLetter = "04";
        break;
      case "ث":
        resPlateLetter = "05";
        break;
      case "ج":
        resPlateLetter = "06";
        break;
      case "چ":
        resPlateLetter = "07";
        break;
      case "ح":
        resPlateLetter = "08";
        break;
      case "خ":
        resPlateLetter = "09";
        break;
      case "د":
        resPlateLetter = "10";
        break;
      case "ذ":
        resPlateLetter = "11";
        break;
      case "ر":
        resPlateLetter = "12";
        break;
      case "ز":
        resPlateLetter = "13";
        break;
      case "ژ":
        resPlateLetter = "14";
        break;
      case "س":
        resPlateLetter = "15";
        break;
      case "ش":
        resPlateLetter = "16";
        break;
      case "ص":
        resPlateLetter = "17";
        break;
      case "ض":
        resPlateLetter = "18";
        break;
      case "ط":
        resPlateLetter = "19";
        break;
      case "ظ":
        resPlateLetter = "20";
        break;
      case "ع":
        resPlateLetter = "21";
        break;
      case "غ":
        resPlateLetter = "22";
        break;
      case "ف":
        resPlateLetter = "23";
        break;
      case "ق":
        resPlateLetter = "24";
        break;
      case "ک":
        resPlateLetter = "25";
        break;
      case "گ":
        resPlateLetter = "26";
        break;
      case "ل":
        resPlateLetter = "27";
        break;
      case "م":
        resPlateLetter = "28";
        break;
      case "ن":
        resPlateLetter = "29";
        break;
      case "و":
        resPlateLetter = "30";
        break;
      case "ه":
        resPlateLetter = "31";
        break;
      case "ی":
        resPlateLetter = "32";
        break;
      case "D":
        resPlateLetter = "33";
        break;
      case "S":
        resPlateLetter = "34";
        break;
      case "&":
        resPlateLetter = "35";
        break;
      default:
        resPlateLetter = "";
        break;
    }
    resPlate =
      plate[0] +
      plate[1] +
      resPlateLetter +
      plate[3] +
      plate[4] +
      plate[5] +
      plate[6] +
      plate[7];
    return resPlate;
  } catch (error) {
    return "";
  }
};

export { getValidPlateNumber, setValidPlateNumber };
